/* eslint-disable react/prop-types, react/jsx-handler-names */

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Select from "react-select";
import {withStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";
import {Grid, NoSsr, Typography, TextField, Paper, Chip, MenuItem, Button, CircularProgress} from "@material-ui/core";
import {Pageview, Cancel} from "@material-ui/icons";
import MUIDataTable from "mui-datatables";
import styles from "./style";
import RedmoService from "../../services/RedmoService";
import {formatDate, parseDate} from "react-day-picker/moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import moment from "moment";
import _ from "lodash";
import {Tag} from "antd";
import "./style.css";

const redmoService = new RedmoService();

function NoOptionsMessage(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.noOptionsMessage}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function inputComponent({inputRef, ...props}) {
    return <div ref={inputRef} {...props} />;
}

function Control(props) {
    return (
        <TextField
            fullWidth
            InputProps={{
                inputComponent,
                inputProps: {
                    className: props.selectProps.classes.input,
                    inputRef: props.innerRef,
                    children: props.children,
                    ...props.innerProps,
                },
            }}
            {...props.selectProps.textFieldProps}
        />
    );
}

function Option(props) {
    return (
        <MenuItem
            buttonRef={props.innerRef}
            selected={props.isFocused}
            component="div"
            style={{
                fontWeight: props.isSelected ? 500 : 400,
            }}
            {...props.innerProps}
        >
            {props.children}
        </MenuItem>
    );
}

function Placeholder(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.placeholder}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function SingleValue(props) {
    return (
        <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
            {props.children}
        </Typography>
    );
}

function ValueContainer(props) {
    return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}


function Menu(props) {
    return (
        <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
            {props.children}
        </Paper>
    );
}

const components = {
    Control,
    Menu,
    NoOptionsMessage,
    Option,
    Placeholder,
    SingleValue,
    ValueContainer,
};


const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "stacked",
};

class IntegrationReactSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            from: undefined,
            to: undefined,
            single: null,
            multi: null,
            isAreaMaLoading: false,
            isAgentsLoading: false,
            isTransLoading: false,
            isTransShow: false,
            suggestions: [],
            trnTblData: [],
            areaManagerValue: null,
            areaManagerList: [],
            isAllAgents: false,
            isAllAreaMan: false
        };
        this.handleFromChange = this.handleFromChange.bind(this);
        this.handleToChange = this.handleToChange.bind(this);
        this.viewTrasactions = this.viewTrasactions.bind(this);
    }


    componentDidMount() {
        this.setState({isAreaMaLoading: true});
        redmoService.getAreaMangers((err, result) => {
            if (err) {
                this.setState({
                    isAreaMaLoading: false,
                    areaManagerList: []
                });
            } else {
                this.setState({
                    isAreaMaLoading: false,
                    areaManagerList: result.results
                });
            }
        });

    }

    showFromMonth() {
        const {from, to} = this.state;
        if (!from) {
            return;
        }
        if (moment(to).diff(moment(from), "months") < 2) {
            this.to.getDayPicker().showMonth(from);
        }
    }


    handleChange = name => value => {
        console.log(name, value);
        this.setState({
            [name]: value,
        });

        if (value.label === "All Agents") {
            this.setState({
                isAllAgents: true
            });
        } else {
            this.setState({
                isAllAgents: false
            });
        }

        if (value.value === "all") {
            this.setState({
                isAllAreaMan: true
            });
        } else {
            this.setState({
                isAllAreaMan: false
            });
        }

        if (name === "areaManagerValue" && value) {
            this.setState({isAgentsLoading: true});
            redmoService.getAgents(value.value, (err, result) => {
                if (err) {
                    this.setState({
                        isAgentsLoading: false,
                        suggestions: []
                    });
                } else {
                    this.setState({
                        isAgentsLoading: false,
                        suggestions: result.results
                    });
                }
            });
        }
    };

    handleMenuOpen = () => {
        this.setState({
            single: null,
            isTransShow: false
        });
    }

    handleMSelectOpen = () => {
        this.setState({
            single: null,
            areaManagerValue: null,
            isTransShow: false
        });
    }

    handleFromChange(from) {
        this.setState({from});
    }

    handleToChange(to) {
        this.setState({to}, this.showFromMonth);
    }

    viewTrasactions() {
        console.log("viewTrnnClickk");
        console.log(this.state.suggestions);
        this.setState({isTransLoading: true});

        let params = {};

        if(this.state.isAllAreaMan){
            params = {
                fromDate: moment(this.state.from).format("YYYY-MM-DD"),
                toDate: moment(this.state.to).format("YYYY-MM-DD"),
                userId: 0,
                isAllAreaMan: this.state.isAllAreaMan,
                isAllAgents: this.state.isAllAgents,
                agents: this.state.suggestions
            };
        }else {
            params = {
                fromDate: moment(this.state.from).format("YYYY-MM-DD"),
                toDate: moment(this.state.to).format("YYYY-MM-DD"),
                userId: this.state.single.value,
                isAllAgents: this.state.isAllAgents,
                agents: this.state.suggestions
            };
        }

        redmoService.getTransactions(params, (err, result) => {

            if (err) {
                this.setState({
                    isTransShow: true,
                    trnTblData: [],
                    isTransLoading: false
                });
            } else {
                let TransactionList = result.results;
                let dataSet = [];
                TransactionList.forEach(trnList => {
                    let inData = [];
                    inData.insert(0, trnList.dateTime.replace(/T/, " ").replace(/\..+/, ""));
                    inData.insert(1, trnList.payUsing);
                    inData.insert(2,
                        <Tag
                            color={_.upperCase(trnList.status) === "SUCCESS" ? "green" : _.upperCase(trnList.status) === "FAILED" ? "red" : ""}>
                            {_.upperCase(trnList.status)}
                        </Tag>
                    );
                    inData.insert(3, trnList.currency);
                    inData.insert(4, trnList.originalAmount);
                    dataSet.push(inData);
                });

                this.setState({
                    isTransShow: true,
                    trnTblData: dataSet,
                    isTransLoading: false
                });
            }
        });

    }

    render() {
        const {classes, theme} = this.props;
        const {
            single, areaManagerValue, isAgentsLoading, isTransLoading, suggestions, isTransShow,
            isAreaMaLoading, isAllAreaMan,
            from, to, trnTblData, areaManagerList
        } = this.state;
        const modifiers = {start: from, end: to};
        //console.log("single",single);
        //console.log("areaManagerValue", areaManagerValue);


        const selectStyles = {
            input: base => ({
                ...base,
                color: theme.palette.text.primary,
                "& input": {
                    font: "inherit",
                },
            }),
        };

        return (
            <div className={classes.root}>

                <Grid
                    container
                    direction="column"
                    justify="flex-start"
                    alignItems="stretch"
                    spacing={16}
                >

                    <Grid item>
                        <Paper>
                            <NoSsr>
                                <Select
                                    className={classes.paperMod}
                                    classes={classes}
                                    textFieldProps={{
                                        label: "Area manager",
                                        InputLabelProps: {
                                            shrink: true,
                                        },
                                    }}
                                    styles={selectStyles}
                                    options={areaManagerList}
                                    components={components}
                                    value={areaManagerValue}
                                    onChange={this.handleChange("areaManagerValue")}
                                    placeholder="Select an area manager"
                                    isClearable
                                    isLoading={isAreaMaLoading}
                                    isDisabled={isAreaMaLoading}
                                    onMenuOpen={() => this.handleMSelectOpen()}
                                />
                            </NoSsr>
                        </Paper>
                    </Grid>


                    {isAllAreaMan ? null :
                        <Grid item>
                            <Paper>
                                <NoSsr>
                                    <Select
                                        className={classes.paperMod}
                                        classes={classes}
                                        textFieldProps={{
                                            label: "Agent",
                                            InputLabelProps: {
                                                shrink: true,
                                            },
                                        }}
                                        styles={selectStyles}
                                        options={suggestions}
                                        components={components}
                                        value={single}
                                        onChange={this.handleChange("single")}
                                        placeholder="Select an agent"
                                        isClearable
                                        isLoading={isAreaMaLoading || isAgentsLoading}
                                        isDisabled={!areaManagerValue || isAreaMaLoading || isAgentsLoading}
                                        onMenuOpen={() => this.handleMenuOpen()}
                                    />
                                </NoSsr>
                            </Paper>
                        </Grid>
                    }


                    <Grid item>
                        {(single || isAllAreaMan) ?
                            <Paper className={classes.paperMod}>
                                <Typography variant="caption" gutterBottom className={classes.durationTxt}>
                                    Transaction Duration
                                </Typography>
                                <div className="InputFromTo">
                                    <DayPickerInput
                                        value={from}
                                        placeholder={`${formatDate(new Date())}`}
                                        format="LL"
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        dayPickerProps={{
                                            selectedDays: [from, {from, to}],
                                            disabledDays: {after: to},
                                            toMonth: to,
                                            modifiers,
                                            numberOfMonths: 2,
                                            onDayClick: () => this.to.getInput().focus(),
                                        }}
                                        onDayChange={this.handleFromChange}
                                    />
                                    {" "}—TO—{" "}
                                    <span className="InputFromTo-to">
                                        <DayPickerInput
                                            ref={el => (this.to = el)}
                                            value={to}
                                            placeholder={`${formatDate(new Date())}`}
                                            format="LL"
                                            formatDate={formatDate}
                                            parseDate={parseDate}
                                            dayPickerProps={{
                                                selectedDays: [from, {from, to}],
                                                disabledDays: {before: from},
                                                modifiers,
                                                month: from,
                                                fromMonth: from,
                                                numberOfMonths: 2,
                                            }}
                                            onDayChange={this.handleToChange}
                                        />
                                    </span>
                                </div>
                            </Paper>
                            :
                            null
                        }
                    </Grid>

                    <Grid item>
                        {(single || isAllAreaMan) ?
                            <Button variant="contained" color="primary" className={classes.button}
                                disabled={isTransLoading}
                                fullWidth={true} onClick={() => {
                                    this.viewTrasactions();
                                }}>
                                <Pageview className={classes.leftIcon}/>
                                View Transactions
                            </Button>
                            : null
                        }
                    </Grid>


                    <Grid item>
                        {(single || isAllAreaMan) ?
                            <div>
                                {isTransLoading ?
                                    <Grid
                                        container
                                        direction="row"
                                        justify="center"
                                        alignItems="flex-start"
                                    >
                                        <Grid item>
                                            <CircularProgress className={classes.loadingCenter} color="secondary"/>
                                        </Grid>
                                    </Grid>
                                    :
                                    <div style={{maxWidth: "100%"}}>
                                        {isTransShow ?
                                            <MUIDataTable
                                                style={{zIndex: -1}}
                                                title={"Transaction"}
                                                data={trnTblData}
                                                columns={["Date", "Paid using", "Status", "Currency", "Amount"]}
                                                options={options}
                                            />
                                            :
                                            null
                                        }
                                    </div>
                                }
                            </div>
                            :
                            null
                        }
                    </Grid>

                </Grid>

            </div>
        );
    }
}

IntegrationReactSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(IntegrationReactSelect);
